import rest from "../axiosRestCalls";
import store from "../../core/redux/Store";
import {
    setDealerLocatorRenderFlag,
    setDealers,
    setDealerServices,
    setDealerServicesFlag
} from "../../core/redux/ActionCreator";
import {API_BASE_PATH, DEALER_API, dealerGeoSearch, dealerSearchBac, dealerServices} from "../restConstants";

const API = API_BASE_PATH + DEALER_API;
class dealerLocatorService{
    /**might need to set the range and brand differently
     * current definitions:
     * range = 50
     * brand = none
     */
    getDealersGeoSearch(latitude, longitude, range, brand) {
        store.dispatch(setDealerLocatorRenderFlag(false));
        let searchInfo = dealerGeoSearch.replace('{latitude}', latitude)
            .replace('{longitude}', longitude)
            .replace('{range}', range)
            .replace('{brand}', brand);
        let url = API + searchInfo;
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setDealers(res.data));
            } else {
                store.dispatch(setDealers([]));
            }
            store.dispatch(setDealerLocatorRenderFlag(true));
        });
    }

    getDealerByBAC(bac) {
        store.dispatch(setDealerLocatorRenderFlag(false));
        let searchInfo = dealerSearchBac.replace('{bac}', bac);
        let url = API + searchInfo;
        rest.get(url).then((res) => {
            console.log(res);
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setDealers(res.data));
            } else {
                store.dispatch(setDealers([]));
            }
            store.dispatch(setDealerLocatorRenderFlag(true));
        });
    }

    /*getDealersNameSearch(dealerName, brand){
        let pathInfo = dealerSearchName.replace('{dealerName}',dealerName)
            .replace('{brand}',brand);

        let url = API + pathInfo;
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setDealers(res.data));
            }
        });
    }*/

    /**might need to set the inNetwork differently
     * current definitions:
     * inNetwork = true
     */
    getServicesByVehicle(bac, year, make, model, tireSize, inNetwork){
        store.dispatch(setDealerServicesFlag(false));
        let pathInfo = dealerServices.replace('{bac}',bac)
            .replace('{year}',year)
            .replace('{make}',make)
            .replace('{model}',model)
            .replace('{tiresize}', tireSize)
            .replace('{innetwork}',inNetwork);

        let url = API + pathInfo;
        rest.get(url).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setDealerServices(res.data));
            }
            store.dispatch(setDealerServicesFlag(true));
        });
    }
}
// eslint-disable-next-line
export default new dealerLocatorService();
